var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',[_c('v-autocomplete',{attrs:{"items":_vm.trainTypes,"rules":[_vm.required],"outlined":"","label":"Tågtyp"},model:{value:(_vm.type),callback:function ($$v) {_vm.type=$$v},expression:"type"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }